<template>
  <div class="image-upload-and-resize">
    <div class="my-8">
      <image-uploader
        :preview="!!isPreviewImage"
        :debug="0"
        :auto-rotate="true"
        :quality="0.6"
        name="fileInput"
        output-format="blob"
        accept="image/*"
        @input="setImage"
      >
        <label slot="upload-label" for="fileInput">
          <figure>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
            >
              <path :d="iconPath" class="path1"></path>
            </svg>
          </figure>
        </label>
      </image-uploader>
    </div>
  </div>
</template>

<script>
import ImageUploader from "vue-image-upload-resize";

export default {
  components: {
    ImageUploader
  },
  props: {
    isPreviewImage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      iconPath: [
        "M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5",
        "-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5z",
        "M30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7",
        "c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28",
        "c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2z",
        "M16 27.875c-4.902 0-8.875-3.973-8.875-8.875",
        "s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875",
        "s-3.973 8.875-8.875 8.875z",
        "M30 14h-4v-2h4v2z"
      ].join(" ")
    };
  },
  methods: {
    setImage(output) {
      this.$emit("confirm", output);
    },
  }
};
</script>

<style scoped>
.image-upload-and-resize ::v-deep #fileInput {
  display: none;
}
</style>
